// extracted by mini-css-extract-plugin
export var createdDate = "_i9-1";
export var divider = "_i9-2";
export var headerDivider = "_i9-3";
export var messagesCard = "_i9-0";
export var messagesContainer = "_i9-6";
export var messagesContainerWrapper = "_i9-4";
export var showLeftPanelButton = "_i9-8";
export var topButtons = "_i9-7";
export var withPadding = "_i9-5";